import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from 'react';
import _ from 'lodash';
export default function debounced(WrappedComponent) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ComponentWithDebounceBehaviour, _React$Component);

    function ComponentWithDebounceBehaviour(props) {
      var _this;

      _classCallCheck(this, ComponentWithDebounceBehaviour);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentWithDebounceBehaviour).call(this, props));

      _defineProperty(_assertThisInitialized(_this), "onChangeTransient", function (e) {
        if (!e) return;
        if (e.persist) e.persist();

        _this.setState({
          transientValue: e.target.value
        }, function () {
          _this.debounceOnChange(e);
        });
      });

      var onChange = props.onChange,
          debounce = props.debounce;
      _this.debounceOnChange = _.debounce(onChange, debounce, {
        leading: true
      });
      _this.state = {
        transientValue: props.value
      };
      return _this;
    }

    _createClass(ComponentWithDebounceBehaviour, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps, nextState) {
        if (!nextProps.debounce) return;

        if (nextProps.value !== nextState.transientValue) {
          this.setState({
            transientValue: nextProps.value
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            debounce = _this$props.debounce,
            value = _this$props.value,
            onChange = _this$props.onChange,
            rest = _objectWithoutProperties(_this$props, ["debounce", "value", "onChange"]);

        var transientValue = this.state.transientValue;
        return React.createElement(WrappedComponent, _extends({
          value: debounce ? transientValue : value,
          onChange: debounce ? this.onChangeTransient : onChange
        }, rest));
      }
    }]);

    return ComponentWithDebounceBehaviour;
  }(React.Component), _temp;
}